// extracted by mini-css-extract-plugin
export default {"couponDownloadBox":"CouponRegister_couponDownloadBox__X3QUe","active":"CouponRegister_active__3ZQtN"};